import { useEffect, useState } from "react";
import {
  fetchZonesPOReports,
  fetchZonePartiesPOReports,
  fetchDescriptionPOReports,
  fetchSubdivisionPOReports,
  fetchPendingOrderReports,
  downloadPendingOrderReport
} from "Service/ApiService"; 
import { showAlert } from "utils/ErrorMessage";
import { showSuccessAlert } from "utils/SuccessMessage";

/* ------------------ DROPDOWN OPTIONS ------------------ */
const useDebounce = (value, delay = 600) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
};

const statusOptions = [
  { label: "Partially Delivered", value: "Partially Delivered" },
  { label: "Not Delivered", value: "Not Delivered" }
];

const PendingOrderReportsController = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const formatCustomerLabel = (p) =>
    `${p?.partyName?.trim() || ""} - ${p?.city?.trim() || ""} - ${p?.partyCode?.trim() || ""}`;
  const isFromApp =  localStorage.getItem('isFromApp') === 'true';
  /* ------------------ STATE ------------------ */
  const [pendingOrders, setPendingOrders] = useState([]);
  const [topCustomers, setTopCustomers] = useState([]);
  const [topQualities, setTopQualities] = useState([]);

  //const [cloading, setcLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [zoneOptions, setZoneOptions] = useState([]);
  const [customerNameOptions, setCustomerNameOptions] = useState([]);
  const [descriptionOptions, setDescriptionOptions] = useState([]);
  const [subdivisionOptions, setSubdivisionOptions] = useState([]);

  const [lastUpdatedDate, setLastUpdatedDate] = useState("");
  const [lastUpdatedTime, setLastUpdatedTime] = useState("");
  const [divisionlist, setdivisionlist] = useState("");

  const [loadingPending, setLoadingPending] = useState(false);
  const [loadingZones, setLoadingZones] = useState(false);
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [loadingDescriptions, setLoadingDescriptions] = useState(false);
  const [loadingSubdivisions, setLoadingSubdivisions] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const cloading =
    loadingPending ||
    loadingZones ||
    loadingCustomers ||
    loadingDescriptions ||
    loadingSubdivisions ||
    loadingDownload;

  const [filters, setFilters] = useState({
    zone: [],
    status: null,
    subdivision: [],
    customerName: [],
    description: null,
    fromDate: "",
    toDate: ""
  });

  const debouncedFilters = useDebounce(filters, 600);
  const [initialLoadDone, setInitialLoadDone] = useState(false);

  useEffect(() => {
    if (cloading) {
      const scrollBarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      document.body.style.position = "fixed";
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.width = "100%";
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    } else {
      const scrollY = document.body.style.top;

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.paddingRight = "";

      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
  }, [cloading]);


  /* ------------------ HANDLERS ------------------ */
  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1); // MUI is 0-based, API is 1-based
  };


  const handleFilterChange = (field) => (value) => {
    // if (
    //   ["zone", "customerName", "subdivision"].includes(field) &&
    //   (!value || value.length === 0)
    // ) {
    //   return;
    // }
    console.log(value)
    setFilters((prev) => ({ ...prev, [field]: value }));
    setPage(1);
  };


  const handleDateFromChange = (date) => {
    console.log(date, 'from date')
    setFilters((prev) => ({ ...prev, fromDate: date }));
    setPage(1);
  };

  const handleDateToChange = (date) => {
    console.log(date, 'to date')
    setFilters((prev) => ({ ...prev, toDate: date }));
    setPage(1);
  };

  /* ------------------ DATA LOAD ------------------ */
  useEffect(() => {
    getPendingOrders();
  }, [
    page,
    filters.zone,
    filters.customerName,
    filters.subdivision,
    filters.status,
    filters.description,
    filters.fromDate,
    filters.toDate
  ]);

  // Zones
  // useEffect(() => {
  //   const loadZones = async () => {
  //     try {
  //       setLoadingZones(true);
  //       const res = await fetchZonesPOReports(user.userCode, "pending");
  //       if (res?.status && Array.isArray(res.zones)) {
  //         setZoneOptions(
  //           res.zones.map((z, idx) => ({
  //             label: z.region?.trim() || "(NO REGION)",
  //             value: `${z.zoneCode}_${idx}`,   // ✅ UNIQUE
  //             zoneCode: z.zoneCode,             // real value
  //             amount: z.amount
  //           }))
  //         );
  //       } else {
  //         setZoneOptions([]);
  //       }
  //     } catch (err) {
  //       console.error("Zone fetch error:", err);
  //       setZoneOptions([]);
  //     } finally {
  //       setLoadingZones(false);
  //     }
  //   };

  //   loadZones();
  // }, [user.userCode]);

  // // Customers / Parties
  // useEffect(() => {
  //   const loadParties = async () => {
  //     try {
  //       setLoadingCustomers(true);
  //       const res = await fetchZonePartiesPOReports(user.userCode, {
  //         type: "pending"
  //       });
  //       // console.error("res.parties", res.parties);
  //       if (res?.status && Array.isArray(res.parties)) {
  //         setCustomerNameOptions(
  //           res.parties.map((p) => ({
  //             label: `${p.partyCode} - ${p.partyName.trim()}`,
  //             value: p.partyCode,
  //             amount: p.amount
  //           }))
  //         );
  //       } else {
  //         setCustomerNameOptions([]);
  //       }
  //     } catch (err) {
  //       console.error("Party fetch error:", err);
  //       setCustomerNameOptions([]);
  //     } finally {
  //       setLoadingCustomers(false);
  //     }
  //   };

  //   loadParties();
  // }, [user.userCode]);

  // Descriptions
  // useEffect(() => {
  //   const loadDescriptions = async () => {
  //     try {
  //       setLoadingDescriptions(true);
  //       const res = await fetchDescriptionPOReports(user.userCode,filters.description == null ? '':filters.description);
  //       if (res?.status && Array.isArray(res.descriptions)) {
  //         console.log("res.descriptions==>",res.descriptions);
  //         setDescriptionOptions(
  //           res.descriptions.map((d) => ({
  //             label: d.description,
  //             value: d.description
  //           }))
  //         );
  //       } else {
  //         setDescriptionOptions([]);
  //       }
  //     } catch (err) {
  //       console.error("Description fetch error:", err);
  //       setDescriptionOptions([]);
  //     } finally {
  //       setLoadingDescriptions(false);
  //     }
  //   };

  //   loadDescriptions();
  // }, [user.userCode]);

  // useEffect(() => {
  //   const loadSubdivisions = async () => {
  //     try {
  //       setLoadingSubdivisions(true);
  //       const res = await fetchSubdivisionPOReports(user.userCode, "pending");

  //       if (res?.status && Array.isArray(res.divisions)) {
  //         setSubdivisionOptions(
  //           res.divisions.map((d) => ({
  //             // label: `${d.divgroup}`, // Mistair - M3
  //             // value: d.dv,                          // M3
  //             // amount:d.amount
  //             label: `${d.divCode} - ${d.divName?.trim()}`,
  //             value: d.divCode,
  //             amount: d.amount
  //           }))
  //         );
  //       } else {
  //         setSubdivisionOptions([]);
  //       }
  //     } catch (err) {
  //       console.error("Subdivision fetch error:", err);
  //       setSubdivisionOptions([]);
  //     } finally {
  //       setLoadingSubdivisions(false);
  //     }
  //   };

  //   loadSubdivisions();
  // }, [user.userCode]);

  // useEffect(() => {
  //   setSubdivisionOptions(hardcodedSubdivisionOptions);
  // }, []);

    const handleCustomerSearch = async (inputValue) => {
    // react-select fires for every key press
    // if (!inputValue || inputValue.length < 3) {
    //   return;
    // }

    try {
      setLoadingCustomers(true);
      const res = await fetchZonePartiesPOReports(user.userCode, {
        search: inputValue,
        type: "pending"
      });

      if (res?.status && Array.isArray(res.parties)) {
        setCustomerNameOptions(
          res.parties.map((p) => ({
            label: formatCustomerLabel(p),
            value: p.partyCode,
            amount: p.amount
          }))
        );
      }
    } catch (err) {
      console.error("Customer search error:", err);
    } finally {
      setLoadingCustomers(false);
    }
  };

   useEffect(() => {
    let alive = true;

    const loadDropdowns = async () => {
      try {
        setLoadingZones(true);
        setLoadingCustomers(true);
        setLoadingDescriptions(true);
        setLoadingSubdivisions(true);

        /* 1️⃣ ZONES */
        const zoneRes = await fetchZonesPOReports(user.userCode, "pending");
        if (alive && zoneRes?.status) {
          setZoneOptions(
            zoneRes.zones.map((z, i) => ({
              label: z.region?.trim() || "(NO REGION)",
              value: `${z.zoneCode}_${i}`,
              zoneCode: z.zoneCode
            }))
          );
        }
        setLoadingZones(false);

        /* 2️⃣ OTHERS PARALLEL */
        const [custRes, descRes, subRes] = await Promise.all([
          fetchZonePartiesPOReports(user.userCode, { type: "pending" }),
          fetchDescriptionPOReports(user.userCode),
          fetchSubdivisionPOReports(user.userCode, "pending")
        ]);

        if (!alive) return;

        if (custRes?.status) {
          setCustomerNameOptions(
            custRes.parties.map((p) => ({
              label: formatCustomerLabel(p),
              value: p.partyCode
            }))
          );
        }

        if (descRes?.status) {
          setDescriptionOptions(
            descRes.descriptions.map((d) => ({
              label: d.description,
              value: d.description
            }))
          );
        }

        if (subRes?.status) {
          setSubdivisionOptions(
            subRes.divisions.map((d) => ({
              label: `${d.divCode} - ${d.divName?.trim()}`,
              value: d.divCode
            }))
          );
        }

        setLoadingCustomers(false);
        setLoadingDescriptions(false);
        setLoadingSubdivisions(false);
      } catch (e) {
        console.error("Dropdown load error", e);
        setLoadingZones(false);
        setLoadingCustomers(false);
        setLoadingDescriptions(false);
        setLoadingSubdivisions(false);
      }
    };

    loadDropdowns();
    return () => (alive = false);
  }, [user.userCode]);

  // AUTO SELECT ALL ZONES
  useEffect(() => {
    if (zoneOptions.length && filters.zone.length === 0) {
      setFilters((p) => ({ ...p, zone: zoneOptions }));
    }
  }, [zoneOptions]);

  // AUTO SELECT ALL CUSTOMERS
  useEffect(() => {
    if (customerNameOptions.length && filters.customerName.length === 0) {
      setFilters((p) => ({ ...p, customerName: customerNameOptions }));
    }
  }, [customerNameOptions]);

  // AUTO SELECT ALL SUBDIVISIONS
  useEffect(() => {
    if (subdivisionOptions.length && filters.subdivision.length === 0) {
      setFilters((p) => ({ ...p, subdivision: subdivisionOptions }));
    }
  }, [subdivisionOptions]);


  const dropdownsLoaded =
    !loadingZones &&
    !loadingCustomers &&
    !loadingDescriptions &&
    !loadingSubdivisions &&
    zoneOptions.length > 0 &&
    customerNameOptions.length > 0 &&
    subdivisionOptions.length > 0;

  const getPendingOrders = async () => {
    try {

      setLoadingPending(true);
      //  console.log("zoneCodes==>",filters.zone);
      const unique = (arr) => [...new Set(arr)];
      const zoneCodes = unique(filters.zone.map(z => z.label)).join(",");
      // console.log("zoneCodes==>",zoneCodes);

      const divisions = filters.subdivision.map((d) => d.value).join(",");
      const parties = filters.customerName.map((c) => c.value).join(",");
     
      const response = await fetchPendingOrderReports(
        user.userCode,
        page,
        zoneCodes,
        parties,
        divisions,
        filters.status?.value,
        filters.description?.value,
        filters.fromDate,
        filters.toDate
      );

      //console.log("Pending Order API →", response);

      if (response?.status) {
        setPendingOrders(response.report || []);
        setTopCustomers(response.topCustomers || []);
        setTopQualities(response.topQualities || []);
        setTotalPages(response.totalPages || 0);
        setTotalRecords(response.totalRecords || 0);
        setLastUpdatedDate(response.lastUpdatedDate || "");
        setLastUpdatedTime(response.lastUpdatedTime || "");
        setdivisionlist(response.userDivisions || "");
      } else {
        setPendingOrders([]);
        setTopCustomers([]);
        setTopQualities([]);
      }
    } catch (err) {
      console.error("Pending order API failed:", err);
    } finally {
      setLoadingPending(false);
    }
  };

  const getReportParams = () => {
    const unique = (arr) => [...new Set(arr)];
    const zoneCodes = unique(filters.zone.map((z) => z.label)).join(",");
    const divisions = filters.subdivision.map((d) => d.value).join(",");
    const parties = filters.customerName.map((c) => c.value).join(",");

    return {
      zoneCodes,
      parties,
      divisions
    };
  };

  const handleDownloadPendingOrderReport = async () => {
    try {
      setLoadingDownload(true);
      const { zoneCodes, parties, divisions } = getReportParams();

      const response = await downloadPendingOrderReport(
        user.userCode,
        page,
        zoneCodes,
        parties,
        divisions,
        filters.status?.value,
        filters.description?.value,
        filters.fromDate,
        filters.toDate
      );

      if (response) {
        showSuccessAlert(
          "Pending Order Report downloaded successfully",
          "Download Pending Order Report"
        );
      }
    } catch (err) {
      console.error("Pending order report download failed:", err);
      showAlert(
        err?.message || "Failed to download Pending Order Report",
        "Download Pending Order Report"
      );
    } finally {
      setLoadingDownload(false);
    }
  };

  useEffect(() => {
    if (
      initialLoadDone ||
      !dropdownsLoaded ||
      !filters.zone.length ||
      !filters.customerName.length ||
      !filters.subdivision.length
    ) {
      return;
    }

    getPendingOrders();        // ✅ CALLED ONCE
    setInitialLoadDone(true);  // 🔒 LOCK
  }, [
    dropdownsLoaded,
    filters.zone.length,
    filters.customerName.length,
    filters.subdivision.length
  ]);


  /* ------------------ USER INTERACTION (DEBOUNCED) ------------------ */
  useEffect(() => {
    if (!initialLoadDone) return;
    getPendingOrders();
  }, [page, debouncedFilters]);
  


  /* ------------------ RETURN ------------------ */
  return {
    pendingOrders,
    topCustomers,
    topQualities,
    cloading,
    page,
    totalPages,
    totalRecords,
    handleChangePage,
    lastUpdatedDate,
    lastUpdatedTime,
    divisionlist,
    filters,
    handleFilterChange,
    handleDateFromChange,
    handleDateToChange,
    handleDownloadPendingOrderReport,

    zoneOptions,
    statusOptions,
    subdivisionOptions,
    customerNameOptions,
    descriptionOptions,
    handleCustomerSearch,
    isFromApp
  };

};

export default PendingOrderReportsController;
